const countryList = [
  { value: 'Bangladesh', name: 'Bangladesh' },
  { value: 'Belgium', name: 'Belgium' },
  { value: 'Burkina Faso', name: 'Burkina Faso' },
  { value: 'Bulgaria', name: 'Bulgaria' },
  { value: 'Bosnia and Herzegovina', name: 'Bosnia and Herzegovina' },
  { value: 'Barbados', name: 'Barbados' },
  { value: 'Wallis and Futuna', name: 'Wallis and Futuna' },
  { value: 'Saint Barthelemy', name: 'Saint Barthelemy' },
  { value: 'Bermuda', name: 'Bermuda' },
  { value: 'Brunei', name: 'Brunei' },
  { value: 'Bolivia', name: 'Bolivia' },
  { value: 'Bahrain', name: 'Bahrain' },
  { value: 'Burundi', name: 'Burundi' },
  { value: 'Benin', name: 'Benin' },
  { value: 'Bhutan', name: 'Bhutan' },
  { value: 'Jamaica', name: 'Jamaica' },
  { value: 'Bouvet Island', name: 'Bouvet Island' },
  { value: 'Botswana', name: 'Botswana' },
  { value: 'Samoa', name: 'Samoa' },
  { value: 'Bonaire, Saint Eustatius and Saba ', name: 'Bonaire, Saint Eustatius and Saba ' },
  { value: 'Brazil', name: 'Brazil' },
  { value: 'Bahamas', name: 'Bahamas' },
  { value: 'Jersey', name: 'Jersey' },
  { value: 'Belarus', name: 'Belarus' },
  { value: 'Belize', name: 'Belize' },
  { value: 'Russia', name: 'Russia' },
  { value: 'Rwanda', name: 'Rwanda' },
  { value: 'Serbia', name: 'Serbia' },
  { value: 'East Timor', name: 'East Timor' },
  { value: 'Reunion', name: 'Reunion' },
  { value: 'Turkmenistan', name: 'Turkmenistan' },
  { value: 'Tajikistan', name: 'Tajikistan' },
  { value: 'Romania', name: 'Romania' },
  { value: 'Tokelau', name: 'Tokelau' },
  { value: 'Guinea-Bissau', name: 'Guinea-Bissau' },
  { value: 'Guam', name: 'Guam' },
  { value: 'Guatemala', name: 'Guatemala' },
  {
    value: 'South Georgia and the South Sandwich Islands',
    name: 'South Georgia and the South Sandwich Islands',
  },
  { value: 'Greece', name: 'Greece' },
  { value: 'Equatorial Guinea', name: 'Equatorial Guinea' },
  { value: 'Guadeloupe', name: 'Guadeloupe' },
  { value: 'Japan', name: 'Japan' },
  { value: 'Guyana', name: 'Guyana' },
  { value: 'Guernsey', name: 'Guernsey' },
  { value: 'French Guiana', name: 'French Guiana' },
  { value: 'Georgia', name: 'Georgia' },
  { value: 'Grenada', name: 'Grenada' },
  { value: 'United Kingdom', name: 'United Kingdom' },
  { value: 'Gabon', name: 'Gabon' },
  { value: 'El Salvador', name: 'El Salvador' },
  { value: 'Guinea', name: 'Guinea' },
  { value: 'Gambia', name: 'Gambia' },
  { value: 'Greenland', name: 'Greenland' },
  { value: 'Gibraltar', name: 'Gibraltar' },
  { value: 'Ghana', name: 'Ghana' },
  { value: 'Oman', name: 'Oman' },
  { value: 'Tunisia', name: 'Tunisia' },
  { value: 'Jordan', name: 'Jordan' },
  { value: 'Croatia', name: 'Croatia' },
  { value: 'Haiti', name: 'Haiti' },
  { value: 'Hungary', name: 'Hungary' },
  { value: 'Hong Kong', name: 'Hong Kong' },
  { value: 'Honduras', name: 'Honduras' },
  { value: 'Heard Island and McDonald Islands', name: 'Heard Island and McDonald Islands' },
  { value: 'Venezuela', name: 'Venezuela' },
  { value: 'Puerto Rico', name: 'Puerto Rico' },
  { value: 'Palestinian Territory', name: 'Palestinian Territory' },
  { value: 'Palau', name: 'Palau' },
  { value: 'Portugal', name: 'Portugal' },
  { value: 'Svalbard and Jan Mayen', name: 'Svalbard and Jan Mayen' },
  { value: 'Paraguay', name: 'Paraguay' },
  { value: 'Iraq', name: 'Iraq' },
  { value: 'Panama', name: 'Panama' },
  { value: 'French Polynesia', name: 'French Polynesia' },
  { value: 'Papua New Guinea', name: 'Papua New Guinea' },
  { value: 'Peru', name: 'Peru' },
  { value: 'Pakistan', name: 'Pakistan' },
  { value: 'Philippines', name: 'Philippines' },
  { value: 'Pitcairn', name: 'Pitcairn' },
  { value: 'Poland', name: 'Poland' },
  { value: 'Saint Pierre and Miquelon', name: 'Saint Pierre and Miquelon' },
  { value: 'Zambia', name: 'Zambia' },
  { value: 'Western Sahara', name: 'Western Sahara' },
  { value: 'Estonia', name: 'Estonia' },
  { value: 'Egypt', name: 'Egypt' },
  { value: 'South Africa', name: 'South Africa' },
  { value: 'Ecuador', name: 'Ecuador' },
  { value: 'Italy', name: 'Italy' },
  { value: 'Vietnam', name: 'Vietnam' },
  { value: 'Solomon Islands', name: 'Solomon Islands' },
  { value: 'Ethiopia', name: 'Ethiopia' },
  { value: 'Somalia', name: 'Somalia' },
  { value: 'Zimbabwe', name: 'Zimbabwe' },
  { value: 'Saudi Arabia', name: 'Saudi Arabia' },
  { value: 'Spain', name: 'Spain' },
  { value: 'Eritrea', name: 'Eritrea' },
  { value: 'Montenegro', name: 'Montenegro' },
  { value: 'Moldova', name: 'Moldova' },
  { value: 'Madagascar', name: 'Madagascar' },
  { value: 'Saint Martin', name: 'Saint Martin' },
  { value: 'Morocco', name: 'Morocco' },
  { value: 'Monaco', name: 'Monaco' },
  { value: 'Uzbekistan', name: 'Uzbekistan' },
  { value: 'Myanmar', name: 'Myanmar' },
  { value: 'Mali', name: 'Mali' },
  { value: 'Macao', name: 'Macao' },
  { value: 'Mongolia', name: 'Mongolia' },
  { value: 'Marshall Islands', name: 'Marshall Islands' },
  { value: 'Macedonia', name: 'Macedonia' },
  { value: 'Mauritius', name: 'Mauritius' },
  { value: 'Malta', name: 'Malta' },
  { value: 'Malawi', name: 'Malawi' },
  { value: 'Maldives', name: 'Maldives' },
  { value: 'Martinique', name: 'Martinique' },
  { value: 'Northern Mariana Islands', name: 'Northern Mariana Islands' },
  { value: 'Montserrat', name: 'Montserrat' },
  { value: 'Mauritania', name: 'Mauritania' },
  { value: 'Isle of Man', name: 'Isle of Man' },
  { value: 'Uganda', name: 'Uganda' },
  { value: 'Tanzania', name: 'Tanzania' },
  { value: 'Malaysia', name: 'Malaysia' },
  { value: 'Mexico', name: 'Mexico' },
  { value: 'Israel', name: 'Israel' },
  { value: 'France', name: 'France' },
  { value: 'British Indian Ocean Territory', name: 'British Indian Ocean Territory' },
  { value: 'Saint Helena', name: 'Saint Helena' },
  { value: 'Finland', name: 'Finland' },
  { value: 'Fiji', name: 'Fiji' },
  { value: 'Falkland Islands', name: 'Falkland Islands' },
  { value: 'Micronesia', name: 'Micronesia' },
  { value: 'Faroe Islands', name: 'Faroe Islands' },
  { value: 'Nicaragua', name: 'Nicaragua' },
  { value: 'Netherlands', name: 'Netherlands' },
  { value: 'Norway', name: 'Norway' },
  { value: 'Namibia', name: 'Namibia' },
  { value: 'Vanuatu', name: 'Vanuatu' },
  { value: 'New Caledonia', name: 'New Caledonia' },
  { value: 'Niger', name: 'Niger' },
  { value: 'Norfolk Island', name: 'Norfolk Island' },
  { value: 'Nigeria', name: 'Nigeria' },
  { value: 'New Zealand', name: 'New Zealand' },
  { value: 'Nepal', name: 'Nepal' },
  { value: 'Nauru', name: 'Nauru' },
  { value: 'Niue', name: 'Niue' },
  { value: 'Cook Islands', name: 'Cook Islands' },
  { value: 'Kosovo', name: 'Kosovo' },
  { value: 'Ivory Coast', name: 'Ivory Coast' },
  { value: 'Switzerland', name: 'Switzerland' },
  { value: 'Colombia', name: 'Colombia' },
  { value: 'China', name: 'China' },
  { value: 'Cameroon', name: 'Cameroon' },
  { value: 'Chile', name: 'Chile' },
  { value: 'Cocos Islands', name: 'Cocos Islands' },
  { value: 'Canada', name: 'Canada' },
  { value: 'Republic of the Congo', name: 'Republic of the Congo' },
  { value: 'Central African Republic', name: 'Central African Republic' },
  { value: 'Democratic Republic of the Congo', name: 'Democratic Republic of the Congo' },
  { value: 'Czech Republic', name: 'Czech Republic' },
  { value: 'Cyprus', name: 'Cyprus' },
  { value: 'Christmas Island', name: 'Christmas Island' },
  { value: 'Costa Rica', name: 'Costa Rica' },
  { value: 'Curacao', name: 'Curacao' },
  { value: 'Cape Verde', name: 'Cape Verde' },
  { value: 'Cuba', name: 'Cuba' },
  { value: 'Swaziland', name: 'Swaziland' },
  { value: 'Syria', name: 'Syria' },
  { value: 'Sint Maarten', name: 'Sint Maarten' },
  { value: 'Kyrgyzstan', name: 'Kyrgyzstan' },
  { value: 'Kenya', name: 'Kenya' },
  { value: 'South Sudan', name: 'South Sudan' },
  { value: 'Suriname', name: 'Suriname' },
  { value: 'Kiribati', name: 'Kiribati' },
  { value: 'Cambodia', name: 'Cambodia' },
  { value: 'Saint Kitts and Nevis', name: 'Saint Kitts and Nevis' },
  { value: 'Comoros', name: 'Comoros' },
  { value: 'Sao Tome and Principe', name: 'Sao Tome and Principe' },
  { value: 'Slovakia', name: 'Slovakia' },
  { value: 'South Korea', name: 'South Korea' },
  { value: 'Slovenia', name: 'Slovenia' },
  { value: 'North Korea', name: 'North Korea' },
  { value: 'Kuwait', name: 'Kuwait' },
  { value: 'Senegal', name: 'Senegal' },
  { value: 'San Marino', name: 'San Marino' },
  { value: 'Sierra Leone', name: 'Sierra Leone' },
  { value: 'Seychelles', name: 'Seychelles' },
  { value: 'Kazakhstan', name: 'Kazakhstan' },
  { value: 'Cayman Islands', name: 'Cayman Islands' },
  { value: 'Singapore', name: 'Singapore' },
  { value: 'Sweden', name: 'Sweden' },
  { value: 'Sudan', name: 'Sudan' },
  { value: 'Dominican Republic', name: 'Dominican Republic' },
  { value: 'Dominica', name: 'Dominica' },
  { value: 'Djibouti', name: 'Djibouti' },
  { value: 'Denmark', name: 'Denmark' },
  { value: 'British Virgin Islands', name: 'British Virgin Islands' },
  { value: 'Germany', name: 'Germany' },
  { value: 'Yemen', name: 'Yemen' },
  { value: 'Algeria', name: 'Algeria' },
  { value: 'United States', name: 'United States' },
  { value: 'Uruguay', name: 'Uruguay' },
  { value: 'Mayotte', name: 'Mayotte' },
  { value: 'United States Minor Outlying Islands', name: 'United States Minor Outlying Islands' },
  { value: 'Lebanon', name: 'Lebanon' },
  { value: 'Saint Lucia', name: 'Saint Lucia' },
  { value: 'Laos', name: 'Laos' },
  { value: 'Tuvalu', name: 'Tuvalu' },
  { value: 'Taiwan', name: 'Taiwan' },
  { value: 'Trinidad and Tobago', name: 'Trinidad and Tobago' },
  { value: 'Turkey', name: 'Turkey' },
  { value: 'Sri Lanka', name: 'Sri Lanka' },
  { value: 'Liechtenstein', name: 'Liechtenstein' },
  { value: 'Latvia', name: 'Latvia' },
  { value: 'Tonga', name: 'Tonga' },
  { value: 'Lithuania', name: 'Lithuania' },
  { value: 'Luxembourg', name: 'Luxembourg' },
  { value: 'Liberia', name: 'Liberia' },
  { value: 'Lesotho', name: 'Lesotho' },
  { value: 'Thailand', name: 'Thailand' },
  { value: 'French Southern Territories', name: 'French Southern Territories' },
  { value: 'Togo', name: 'Togo' },
  { value: 'Chad', name: 'Chad' },
  { value: 'Turks and Caicos Islands', name: 'Turks and Caicos Islands' },
  { value: 'Libya', name: 'Libya' },
  { value: 'Vatican', name: 'Vatican' },
  { value: 'Saint Vincent and the Grenadines', name: 'Saint Vincent and the Grenadines' },
  { value: 'United Arab Emirates', name: 'United Arab Emirates' },
  { value: 'Andorra', name: 'Andorra' },
  { value: 'Antigua and Barbuda', name: 'Antigua and Barbuda' },
  { value: 'Afghanistan', name: 'Afghanistan' },
  { value: 'Anguilla', name: 'Anguilla' },
  { value: 'U.S. Virgin Islands', name: 'U.S. Virgin Islands' },
  { value: 'Iceland', name: 'Iceland' },
  { value: 'Iran', name: 'Iran' },
  { value: 'Armenia', name: 'Armenia' },
  { value: 'Albania', name: 'Albania' },
  { value: 'Angola', name: 'Angola' },
  { value: 'Antarctica', name: 'Antarctica' },
  { value: 'American Samoa', name: 'American Samoa' },
  { value: 'Argentina', name: 'Argentina' },
  { value: 'Australia', name: 'Australia' },
  { value: 'Austria', name: 'Austria' },
  { value: 'Aruba', name: 'Aruba' },
  { value: 'India', name: 'India' },
  { value: 'Aland Islands', name: 'Aland Islands' },
  { value: 'Azerbaijan', name: 'Azerbaijan' },
  { value: 'Ireland', name: 'Ireland' },
  { value: 'Indonesia', name: 'Indonesia' },
  { value: 'Ukraine', name: 'Ukraine' },
  { value: 'Qatar', name: 'Qatar' },
  { value: 'Mozambique', name: 'Mozambique' },
]

countryList.sort((a, b) => a.name.localeCompare(b.name));

export default countryList
